// src/components/Teams/AddMemberForm.js
import React, { useState } from 'react';
import { Form, Button, InputGroup, Spinner } from 'react-bootstrap';

const AddMemberForm = ({ onSubmit, loading }) => {
    const [email, setEmail] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        if (email.trim()) {
            onSubmit({ email });
            setEmail('');
        }
    };

    return (
        <Form onSubmit={handleSubmit}>
            <InputGroup className="mb-3">
                <Form.Control
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Email uživatele"
                    required
                />
                <Button
                    type="submit"
                    variant="primary"
                    disabled={loading}
                >
                    {loading ? (
                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                    ) : (
                        <i className="fas fa-user-plus"></i>
                    )}
                </Button>
            </InputGroup>
        </Form>
    );
};

export default AddMemberForm;